import axios from "axios";
import { loginreq, req, reqPost } from "./axiosFun";


//审核
export const examineApi = params => {
    return req("post", "/app-yijiu-backstage/auditMerchantState", params);
};
// 商家列表 
export const merchantListApi = params => {

    console.log(params,'商家列表')
    return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getAdminMerchantList?token=${localStorage.getItem("logintoken")}&contactPhone=${params.contactPhone}&contactName=${params.contactName}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查看机构详情 
export const merchantDetails = params => {
    return req("get", "/app-yijiu-backstage/getAdminMerchantInfo", params);
};





// WEBPACK FOOTER //
// ./src/api/merchant.js